import LocalizedStrings from "react-localization";
import { CFooter } from "@coreui/react";

const Footer = () => {
  return (
    <CFooter position="fixed" style={styles.footer}>
      <div>{strings.copyright}</div>
    </CFooter>
  );
};

const styles = {
  footer: {
    backgroundColor: "#14547b",
    color: "white",
    justifyContent: "center",
    textAlign: "center",
  },
};

const strings = new LocalizedStrings({
  es: {
    copyright: `Cima IoT @ ${new Date().getFullYear()} - Todos los derechos reservados`,
  },
});

export default Footer;
